export const collectEmail = async (email, phone) => {
    // API CALL
  setTimeout(() => {
    return true;
  }, 3000);
};
